import styled from 'styled-components';
import { Box } from '@bechtel/gds';

export const DrawingListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  height: calc(100vh - 210px);
  overflow-y: auto;
`;
